/**
 * Validation utilities for common data validation patterns
 */

/**
 * Checks if a community ID is valid (not a placeholder like all zeros)
 * @param communityId - The community ID to validate
 * @returns true if the community ID is valid, false otherwise
 */
export function isValidCommunityId(communityId?: string | null): boolean {
  if (!communityId) return false;
  // Filter out placeholder IDs that are all zeros
  return !/^0+$/.test(communityId);
}
